<template>
  <div class="footer">
    <div class="footer_middle">
      <p>友情链接：</p>
      <ul>
        <li><a href="http://www.qixingdiman.com/">七星迪曼</a>|</li>
        <li><a href="http://etshop.elongtian.com/">电商平台开发</a>|</li>
        <li><a href="https://www.ofcc.org.cn/">中绿华夏</a>|</li>
        <li><a href="http://www.gyguanggao.com/">贵阳标识标牌</a>|</li>
        <li><a href="http://www.9511.com.cn/">华信仪表</a>|</li>
        <li><a href="https://www.hzwancll.com/">杭州APP开发</a>|</li>
        <li><a href="https://www.bmac.com.cn/">市政交通一卡通</a>|</li>
      </ul>
    </div>
    <div class="container">
      <dl><dt><img src="../../assets/footerImages/ylt.png" alt=""></dt></dl>
      <dl><dt>电商解决方案</dt>
        <dd><a :href="elt_url + '/shopping_mall/O2O.html'">O2O</a></dd>
        <dd><a :href="elt_url + '/shopping_mall/B2B.html'">B2B</a></dd>
        <dd><a :href="elt_url + '/shopping_mall/B2B2C.html'">B2B2C</a></dd>
        <dd><a :href="elt_url + '/shopping_mall/B2C.html'">B2C</a></dd>
        <dd><a :href="elt_url + '/shopping_mall/S2B2C.html'">S2B2C</a></dd>
      </dl>
      <dl><dt>定制开发解决方案</dt>
        <dd><a :href="elt_url + '/solution/product_consulting.html'">互联网化产品咨询</a></dd>
        <dd><a :href="elt_url + '/solution/experience_consulting.html'">用户体验咨询</a></dd>
        <dd><a :href="elt_url + '/solution/micro_platform.html'">微平台</a></dd>
        <dd><a :href="elt_url + '/solution/mobile_app.html'">移动应用开发</a></dd>
        <dd><a :href="elt_url + '/solution/business_app.html'">业务应用开发</a></dd>
        <dd><a :href="elt_url + '/solution/website.html'">品牌官网/集团门户</a></dd>
        <dd><a :href="elt_url + '/solution/h5.html'">H5互动营销/小游戏开发</a></dd>
        <dd><a :href="elt_url + '/solution/data.html'">数据可视化</a></dd>
        <dd><a :href="elt_url + '/solution/information.html'">信息门户/电子政务平台</a></dd>
      </dl>
      <dl><dt><img src="../../assets/footerImages/logo.png" alt=""></dt></dl>
      <dl><dt>服务</dt>
        <dd><a :href="qxdm_url + '/serviceinfo/1.html'">品牌管理</a></dd>
        <dd><a :href="qxdm_url + '/serviceinfo/2.html'">整合营销</a></dd>
        <dd><a :href="qxdm_url + '/serviceinfo/3.html'">新闻公关</a></dd>
        <dd><a :href="qxdm_url + '/serviceinfo/5.html'">代运营/托管服务</a></dd>
      </dl>
      <dl><dt>关于我们</dt>
        <dd><a :href="qxdm_url + '/aboutus.html'">公司介绍</a></dd>
        <dd><a :href="qxdm_url + '/contactus.html'">联系我们</a></dd>
      </dl>
    </div>
<!--    <div class="container">-->
<!--      -->
<!--    </div>-->
    <div class="footer_btm">
      <div class="footer_dizhi">
        <p class="footer_dizhi_p1"><span style="color: #ba9a6c;">地址：</span>北京市朝阳区十里河新华国际广场D座1102室</p>
        <p class="footer_dizhi_p1"><span style="color: #ba9a6c;">电话：</span>+86 010 8586 8064</p>
      </div>
      <p>
        Copyright © 2003-2021, eLongtian Network Technology Corporation Limited, All Rights Reserved.
        <a :href="elt_url + '/shopping_mall/O2O.html'" style="text-decoration: none;color: inherit;">京ICP备19004758号</a>
        公安备案号：1101051796
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      flag: 'none',
      elt_url: 'http://www.elongtian.com',
      qxdm_url: 'http://www.qixingdiman.com'
    }
  },
  methods: {
    // wxShow () {
    //   this.flag === 'none' ? this.flag = 'inline' : this.flag = 'none'
    // }
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
ul,li,ol {
  list-style: none;
}
.footer {
  background: #000000;
  position: relative;
  text-align: left;
  z-index: 9;
  a {
    text-decoration: none;
  }
  .footer_middle {
    width: 1150px;
    margin: 0px auto 0;
    padding-top: 30px;
    padding-left: 80px;
    p {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;
    }
    ul {
      overflow: hidden;
      padding-left: 20px;
      li {
        float: left;
        margin-left: 10px;
        color: #999999;
        line-height: 42px;
        font-size: 14px;
        a {
          font-size: 14px;
          color: #9f9f9f;
          margin-right: 10px;
          text-decoration: none;
        }
      }
    }
  }
  .container:nth-of-type(3) {
    border-bottom: none;
    padding-top: 28px!important;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 65px !important;
    box-sizing: border-box;
    overflow: hidden;
    padding-bottom: 28px;
    border-bottom: 1px dashed rgba(255,255,255,.2);
    &::before {
      display: table;
      content: " ";
    }
    dl:nth-child(1) {
      width: 15%;
      margin-left: 0;
    }
    dl:nth-child(3) {
      width: 15%;
    }
    dl:nth-child(4) {
      width: 15%;
      margin-left: 50px;
    }
    dl:nth-child(5) {
      width: 11%;
      margin-left: 50px;
    }
    dl:nth-child(6) {
      width: 7%;
      margin-left: 30px;
    }
    dl {
      width: 11%;
      float: left;
      margin-left: 50px;
      color: #c6c6c7;
      dt {
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 24px;
        color: #F0F3F6;
      }
      dd {
        font-size: 15px;
        margin-bottom: 6px;
        a {
          font-size: 13px;
          color: #9f9f9f;
        }
        img {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
    &::after {
      clear: both;
    }
  }
  .footer_btm {
    background: #000;
    padding: 30px 0 !important;
    font-size: 12px;
    line-height: 20px;
    color: #9a9a9a;
    width: 1070px !important;
    margin: 0 auto;
    .footer_dizhi {
      width: 600px;
      margin: 0 auto 20px auto;
      p {
        font-size: 14px;
      }
    }
    &>p {
      text-align: center;
    }
  }
}
@media screen and (max-width: 768px ) {
  .footer {
    height: auto;
    .footer_middle {
      width: 90%;
      padding-left: 0;
    }
    .container {
      width: 100%;
      margin: 0 auto;
      padding-top: 0.65rem !important;
      box-sizing: border-box;
      dl:nth-child(1) {
        margin-left: 0.6rem;
      }
      dl:nth-child(1) {
        width: 100%;
        margin-left: 0.6rem;
      }
      dl:nth-child(3) {
        width: 100%;
        margin-left: 0.6rem;
      }
      dl:nth-child(4) {
        width: 100%;
        margin-left: 0.6rem;
      }
      dl:nth-child(5) {
        width: 100%;
        margin-left: 0.6rem;
      }
      dl:nth-child(6) {
        width: 100%;
        margin-left: 0.6rem;
      }
      dl {
        float: none;
        font-size: 18px;
        width: 90%;
        margin-left: 0.6rem;
        margin-top: .5rem;
        dt {
          font-size: 18px;
          margin-bottom: 0;
          img {
            margin-right: 0.3rem;
          }
        }
        dd {
          display: inline-block;
          font-size: 15px;
          color: #9a9a9a;
          text-align: center;
          margin-bottom: 0.06rem;
          margin-right: .06rem;
          img {
            width: 60%;
            margin-left: 0.6rem;
          }
        }
      }
    }
    .footer_btm {
      width: 92% !important;
      position: relative;
      .footer_dizhi {
        width: 7rem;
        margin: 0 auto 20px auto;
        p {
          font-size: 14px;
        }
      }
    }
  }

}
</style>
